/* Quick add to cart for any card on the site.
   Buttons opt in with data-quick-add + data-variant. Runs once per page even
   though several sections each request the file. */
(function () {
  if (window.__shungiteQuickAdd) return;
  window.__shungiteQuickAdd = true;

  var GIFT = document.documentElement.getAttribute('data-gift-note') ||
             'Free 100g raw shungite included';

  /* ---------- toast ---------------------------------------------------- */
  var toast, toastTimer;
  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'sh-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<div class="sh-toast-in">' +
        '<img class="sh-toast-img" alt="" hidden>' +
        '<div class="sh-toast-tx">' +
          '<strong class="sh-toast-t"></strong>' +
          '<span class="sh-toast-gift">' +
            '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">' +
            '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>' +
            '<span></span>' +
          '</span>' +
        '</div>' +
        '<a class="sh-toast-cta" href="/cart">View cart</a>' +
      '</div>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(title, img, withGift) {
    // Where the reward bar exists it takes this over: it shows what was added
    // AND the progress towards the free stickers, in one element, instead of a
    // floating card that covers the page and then vanishes. The toast stays as
    // the fallback for pages with no reward bar - the cart page, for one.
    if (document.getElementById('shRewardBar')) {
      document.dispatchEvent(new CustomEvent('shungite:added', {
        detail: { title: title, img: img, withGift: withGift }
      }));
      return;
    }
    var t = ensureToast();
    t.querySelector('.sh-toast-t').textContent = title;
    // one gift per order, so only say it on the add that starts the cart
    var giftRow = t.querySelector('.sh-toast-gift');
    giftRow.querySelector('span').textContent = GIFT;
    giftRow.hidden = !withGift;
    var im = t.querySelector('.sh-toast-img');
    if (img) { im.src = img; im.hidden = false; } else { im.hidden = true; }
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 4200);
  }

  /* ---------- cart count ------------------------------------------------ */
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          '.cart-count-bubble span:not(.visually-hidden), [data-cart-count]'
        ).forEach(function (el) { el.textContent = cart.item_count; });
        var bubbleHost = document.querySelector('#cart-icon-bubble');
        if (bubbleHost && !bubbleHost.querySelector('.cart-count-bubble') && cart.item_count) {
          var b = document.createElement('div');
          b.className = 'cart-count-bubble';
          b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          bubbleHost.appendChild(b);
        }
        document.dispatchEvent(new CustomEvent('shungite:cart-updated', { detail: cart }));
        return cart;
      })
      .catch(function () { return null; });
  }

  /* ---------- keep our own cart sections honest -------------------------- */
  /* Spotlight re-renders ITS sections after a quantity change - its line items
     and its cart bubble. Ours are invisible to it: measured on the cart page,
     the basket went from 14,20 to 35,50 on the server while the subtotal, the
     gift bar and the sticker ladder all still showed the first number. A
     customer could raise a quantity and read a total that was no longer true.

     Rather than reverse-engineer the theme's own render path, anything of ours
     that depends on the cart carries data-sh-section and re-renders itself from
     the Section Rendering API whenever the cart is written to. */
  var refreshTimer;
  function refreshSections() {
    var nodes = document.querySelectorAll('[data-sh-section]');
    if (!nodes.length) return;
    [].forEach.call(nodes, function (el) {
      var id = el.getAttribute('data-sh-section');
      if (!id) return;
      fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html')
                        .querySelector('[data-sh-section="' + id + '"]');
          if (!fresh) return;
          el.innerHTML = fresh.innerHTML;
          el.className = fresh.className;
        })
        .catch(function () {});
    });
  }

  /* Any cart write, whoever made it - our quick add, the theme's quantity
     stepper, a remove link - is the signal. */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isWrite = /\/cart\/(add|change|update|clear)/.test(url);

    /* Called with `window`, never with `this`.

       This wrapper sits in front of EVERY fetch on the page, including
       Shopify's own scripts and any app's. Most of those are ES modules, and
       module code is strict, so when they call bare `fetch(url)` the `this`
       inside here is undefined - and native fetch invoked with an undefined
       receiver throws "Illegal invocation" in Chrome. That would not have
       broken the cart; it would have broken whichever third-party script
       happened to call fetch first, with a stack trace pointing at them and not
       at us. Binding to window is what a detached fetch reference expects. */
    var out = nativeFetch.apply(window, arguments);

    if (!isWrite) return out;
    return out.then(function (res) {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () { refreshCount().then(refreshSections); }, 120);
      return res;
    });
  };

  /* ---------- add ------------------------------------------------------- */
  document.addEventListener('click', function (ev) {
    /* ev.target is not always an Element - a synthetic click dispatched on
       document, or on the document itself, has no closest() and the old line
       threw on every such click. Delegated handlers run on every click on the
       page, so a throw here is a throw in the hot path. */
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;
    var btn = t.closest('[data-quick-add]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.disabled || btn.classList.contains('busy')) return;

    var id = btn.getAttribute('data-variant');
    if (!id) return;

    btn.classList.add('busy');
    var original = btn.innerHTML;

    /* OPTIONAL LINE PROPERTIES.

       Some products need a word on the line as well as a variant id. Build a
       Bag is the case that forced this: its only option is the weight, and the
       stone SIZE is a line property the bag builder sets. A quick add that
       posts the variant alone produces a bag with no size on it, which is an
       order line nobody can pack.

       So a button may carry data-props with a JSON object, and it is merged
       into the item. Bad JSON is ignored rather than thrown: a malformed
       attribute should cost the customer the property, not the add. */
    var item = { id: Number(id), quantity: 1 };
    var rawProps = btn.getAttribute('data-props');
    if (rawProps) {
      try {
        var parsed = JSON.parse(rawProps);
        if (parsed && typeof parsed === 'object') item.properties = parsed;
      } catch (e) {}
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('busy');
        if (!res.ok) {
          btn.classList.add('err');
          btn.innerHTML = res.d && res.d.description ? 'Unavailable' : 'Try again';
          setTimeout(function () {
            btn.classList.remove('err'); btn.innerHTML = original;
          }, 2600);
          return;
        }
        btn.classList.add('done');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">' +
                        '<polyline points="20 6 9 17 4 12"/></svg> Added';
        setTimeout(function () {
          btn.classList.remove('done'); btn.innerHTML = original;
        }, 2200);
        refreshCount().then(function (cart) {
          // cart.item_count === 1 means this add is what started the cart,
          // so it is the only moment the free 100g is news
          var firstAdd = !cart || cart.item_count <= 1;
          showToast(btn.getAttribute('data-title') || 'Added to cart',
                    btn.getAttribute('data-img') || '', firstAdd);
        });
        // on the cart page the line items are now out of date
        if (document.querySelector('[data-cart-reload]')) {
          setTimeout(function () { window.location.reload(); }, 900);
        }
      })
      .catch(function () {
        btn.classList.remove('busy');
        btn.innerHTML = original;
      });
  });

  /* ---------- the one piece of this that other code needs -----------------

     The product page's own buy form posts to /cart/add the ordinary way,
     which means Shopify answers with a redirect to /cart. Someone who adds a
     pyramid is taken off the pyramid page and dropped into a cart they did
     not ask to see, which ends the browse. It should behave like every other
     add button on the site: stay put, say it worked.

     That form carries a quantity and variant options, which the data-quick-add
     buttons do not, so it cannot simply become one. It calls this instead, and
     the toast, the cart-count refresh and the free-gift line stay in one place
     rather than being written twice. */
  window.shungiteQuickAdd = {
    add: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      });
    },
    announce: function (title, img) {
      return refreshCount().then(function (cart) {
        var firstAdd = !cart || cart.item_count <= 1;
        showToast(title || 'Added to cart', img || '', firstAdd);
        return cart;
      });
    }
  };
})();
